<template>
  <el-input-number
    size="mini"
    v-if="!disabled"
    :value="value"
    @input="onInput"
    @change="onChange"
    :clearable="clearable"
    style="width: 100%"
    controls-position="right"
    v-bind="$attrs"
    :placeholder="placeholder"
  ></el-input-number>
  <span v-else>{{ value }}</span>
</template>
<script>
import EditMixin from "./edit-mixin";
export default {
  mixins: [EditMixin],
  props: {
    value: {
      type: Number,
      required: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: "请输入",
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    onChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-input-number {
  ::v-deep {
    .el-input {
      .el-input__inner {
        text-align: left;
        padding: 0 30px 0 8px;
      }
    }
  }
}
</style>
